import { ReactElement, ReactNode, useId } from "react";
import './input-checkbox.css'
import { clsx, inputOnKeyUp } from "../../functions.ts";
import { PropertiesAutoFillState } from "../../state/types.ts";

export default function InputCheckbox (props: {
	label: string,
	value: boolean,
  auto_filled?: PropertiesAutoFillState,
  infoButton?: ReactNode,
  onChange: (value: boolean) => void,
}){
  const id = useId();
  return <div className={"input input-checkbox"}>
        <div aria-hidden className={"input__label"}></div>
        <div tabIndex={0} role="checkbox" aria-checked={props.value} aria-labelledby={id+"-label"} className="input-checkbox__container"
         onClick={()=>{props.onChange(!(props.value || false))}}
         onKeyUp={(event)=>inputOnKeyUp(event, ()=>{props.onChange(!(props.value || false))})}
         >
          <div aria-hidden className={clsx("input-checkbox__box", props.value && "input-checkbox__box--active")}>
          </div>
          <span className={"input-checkbox__label"} id={id+"-label"} dangerouslySetInnerHTML={{__html:props.label}}></span>
        </div>
        {props.infoButton}
    </div>
}
